import React, { useContext, useEffect, useState } from "react";
import UserPanelHeader from "../components/UserPanelHeader";
import UserBookingCard from "../components/UserBookingCard";
import Footer from "../components/Footer";
import { AuthContext } from "../context/auth";
import { ExpiringContext } from "../context/ExpiringBookings";
import SuccessAlert from "../admin/components/SuccessAlert";
import ErrorAlert from "../admin/components/ErrorAlert";
import NothingToShow from "../components/NothingToShow";

export default function UserBookings() {
  const { authorizeUserData, setAuthorizeUserData } = useContext(AuthContext);
  const expireCheckComplete = useContext(ExpiringContext);

  // State handling
  const [usersData, setUsersData] = useState();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(true);
  const [fetchedBookings, setFetchedBookings] = useState([]);
  const [fetchedPendingBookings, setFetchedPendingBookings] = useState([]);

  if (loading && authorizeUserData) {
    setUsersData(authorizeUserData);
    setLoading(false);
  }

  // Upload Image Handling
  const userImgHandler = (e) => {
    const imgFile = e.target.files[0];
    if (imgFile) {
      const imgReader = new FileReader();
      imgReader.readAsDataURL(imgFile);
      imgReader.onloadend = () => {
        setUsersData({
          ...usersData,
          user_img: imgReader.result,
        });
        setAuthorizeUserData({
          ...authorizeUserData,
          user_img: imgReader.result,
        });
      };
      imgReader.onerror = (error) => {
        console.log(error);
      };
    }
  };

  // --------- Reading/Fetching Bookings From Database ---------
  const readingBookings = async () => {
    const response = await fetch("https://hotelbnb-backend.onrender.com/read-bookings");

    if (!response.ok) {
      setSuccess("");
      setError("Bookings can't be fetched");
    } else if (response.ok) {
      const result = await response.json();
      setTimeout(() => {
        setError("");
      }, 10000);
      const filteringBookings = result.filter(
        (booking) =>
          booking.booking_holder_email == authorizeUserData?.user_email
      );
      setFetchedBookings(filteringBookings);
    }
  };

  // --------- Reading/Fetching Pending Bookings From Database ---------
  const readingPendingBookings = async () => {
    const response = await fetch("https://hotelbnb-backend.onrender.com/read-pending-bookings");

    if (!response.ok) {
      setSuccess("");
      setError("Pending Bookings can't be fetched");
    } else if (response.ok) {
      const result = await response.json();
      setTimeout(() => {
        setError("");
      }, 10000);
      const filteringBookings = result.filter(
        (booking) =>
          booking.booking_holder_email == authorizeUserData?.user_email
      );
      setFetchedPendingBookings(filteringBookings);
    }
  };

  useEffect(() => {
    readingBookings();
    readingPendingBookings();
  }, [authorizeUserData, expireCheckComplete]);

  return (
    <>
      {/* Showing Alert based on http request response Start */}
      <div className="container-fluid p-0">
        <div className="row app-container mt-3">
          {success && <SuccessAlert successMsg={success} />}
          {error && <ErrorAlert errorMsg={error} />}
        </div>
      </div>
      {/* Showing Alert based on http request response End */}

      {/* User Panel Header Start */}
      <UserPanelHeader
        userName={usersData?.user_first_name}
        userEmail={usersData?.user_email}
        userImg={usersData?.user_img}
        userImgHandler={userImgHandler}
      />
      {/* User Panel Header End */}

      {/* All User's Bookings Section Start */}
      <div className="container-fluid p-0 user-bookings">
        <div className="row cards-container user-bookings-row justify-content-start align-items-center">
          {!fetchedBookings.length && !fetchedPendingBookings.length ? <NothingToShow /> : ""}
          
          {fetchedPendingBookings.length ? <NothingToShow text="Pending Bookings will be deleted after 15 minutes" /> : ""}

          {fetchedPendingBookings?.map((singleBooking) => {
            return (
              <UserBookingCard
                key={singleBooking._id}
                img={singleBooking.room_img}
                bookingHolderName={singleBooking.booking_holder_name}
                bookingId={`bid${(singleBooking._id).slice(0, 5)}of${(singleBooking.booking_holder_email).slice(0, 3)}`}
                fromDate={singleBooking.booking_from}
                toDate={singleBooking.booking_to}
                hotelName={singleBooking.booking_hotel}
                room={singleBooking.booking_room_number}
                rentPerDay={singleBooking.booking_room_price}
                totalAmount={singleBooking.booking_total}
                bookingStatus={singleBooking.booking_status}
                bookingObject={singleBooking}
              />
            );
          })}

          {fetchedBookings?.map((singleBooking) => {
            return (
              <UserBookingCard
                key={singleBooking._id}
                img={singleBooking.room_img}
                bookingHolderName={singleBooking.booking_holder_name}
                bookingId={`bid${(singleBooking._id).slice(0, 5)}of${(singleBooking.booking_holder_email).slice(0, 3)}`}
                fromDate={singleBooking.booking_from}
                toDate={singleBooking.booking_to}
                hotelName={singleBooking.booking_hotel}
                room={singleBooking.booking_room_number}
                rentPerDay={singleBooking.booking_room_price}
                totalAmount={singleBooking.booking_total}
                bookingStatus={singleBooking.booking_status}
                bookingObject={singleBooking}
              />
            );
          })}
        </div>
      </div>
      {/* All User's Bookings Section End */}

      {/* Footer Start */}
      <Footer />
      {/* Footer End */}
    </>
  );
}
